module.exports = __webpack_public_path__ + "static/media/dashboard.40ada698.svg";